import config from "@src/utilities/config";

export const ApplicationName = config.auth.authClientId;

export const QueryParameterNames = {
  ReturnUrl: "returnUrl",
  Message: "message",
};

// export const QueryParameterNamesForLogin = {
//   ReturnUrl: window.location.origin,
// };

export const LogoutActions = {
  LogoutCallback: "logout-callback",
  Logout: "logout",
  LoggedOut: "logged-out",
};

export const LoginActions = {
  Login: "login",
  LoginCallback: "login-callback",
  LoginFailed: "login-failed",
  Profile: "profile",
  Register: "register",
};

// const authority_url = DEBUG ? "https://is.development.rightio.co.uk" : "https://is.rightio.co.uk";
// const prefix = `${config.authority_url}/Identity/Account`;
// const prefix = `${config.authority_url}/Account`;
// const prefixNoAccount = `${config.authority_url}`;

const authPrefix = `/authentication`;

export const ApplicationPaths = {
  DefaultLoginRedirectPath: "/",
  ApiAuthorizationClientConfigurationUrl: `${config.auth.authService}/_configuration/${ApplicationName}`,
  ApiAuthorizationPrefix: authPrefix,
  Login: `${authPrefix}/${LoginActions.Login}`,
  LoginFailed: `${authPrefix}/${LoginActions.LoginFailed}`,
  LoginCallback: `${authPrefix}/${LoginActions.LoginCallback}`,
  Register: `${authPrefix}/${LoginActions.Register}`,
  Profile: `${authPrefix}/${LoginActions.Profile}`,
  LogOut: `${authPrefix}/${LogoutActions.Logout}`,
  LoggedOut: `${authPrefix}/${LogoutActions.LoggedOut}`,
  LogOutCallback: `${authPrefix}/${LogoutActions.LogoutCallback}`,
  IdentityRegisterPath: "Identity/Account/Register",
  IdentityManagePath: "Manage",
};
